var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMenu28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 5a1.5 1.5 0 1 0 0 3h19a1.5 1.5 0 0 0 0-3h-19ZM3 14a1.5 1.5 0 0 1 1.5-1.5h19a1.5 1.5 0 0 1 0 3h-19A1.5 1.5 0 0 1 3 14Zm0 7.5A1.5 1.5 0 0 1 4.5 20h19a1.5 1.5 0 0 1 0 3h-19A1.5 1.5 0 0 1 3 21.5Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu28);
export default __webpack_public_path__ + "static/media/menu_28.38ccfbe3.svg";
export { ForwardRef as ReactComponent };